import { render } from "./Nerostarx.vue?vue&type=template&id=a3e80338&scoped=true"
import script from "./Nerostarx.vue?vue&type=script&lang=js"
export * from "./Nerostarx.vue?vue&type=script&lang=js"

import "./Nerostarx.vue?vue&type=style&index=0&id=a3e80338&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3e80338"]])

export default __exports__